module.exports = __webpack_public_path__ + "img/deploy.61be69ae.png";